<template>
  <van-nav-bar
    title="处方审核系统"
    fixed
    placeholder
  >
    <template #right>
      <van-icon name="chat-o" :badge="messageList" @click="handleMessage" />
    </template>
  </van-nav-bar>
</template>

<script>
import { getPresLog } from '@/api/user'
export default {
  name: 'Header',
  props: {
    messageList: {
      type: Number,
      default: 0,
    }
  },
  data(){
    return {

    }
  },
  mounted() {

  },
  methods:{
    // 进行消息列表跳转
    handleMessage() {
      this.$router.push({ name: 'message' })
    }
  }
}
</script>